import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, Link, Typography, useTheme } from '@mui/material';
import logo_grey60p from '@pn/ui/images/stackdx_logo_grey60p.svg';
import logo_white from '@pn/ui/images/stackdx_logo_white.svg';
import { ExternalLink } from './ExternalLink';

export const Footer = () => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        color: theme.palette.text.disabled,
        padding: theme.spacing(1),
        paddingTop: theme.spacing(8),
      })}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'space-between',
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'start',
          },
        })}
      >
        <Box>
          <Typography variant="body2">
            Stack Technologies Ltd. is a privately held technology company in
            Calgary, Alberta, Canada.
          </Typography>
          <Typography variant="body2">
            &copy; 2025 Stack Technologies Ltd. &bull;{' '}
            <ExternalLink href="/terms">Terms</ExternalLink> &bull;{' '}
            <ExternalLink href="/privacy">Privacy</ExternalLink>
          </Typography>
          <Link href={'https://stackdx.com'} target="_blank">
            <img
              src={theme.palette.mode === 'light' ? logo_grey60p : logo_white}
              alt="StackDX"
              style={{ maxWidth: 140 }}
            />
          </Link>

          <Box mt={2} />
        </Box>
        <Box>
          <Typography variant="body1" gutterBottom>
            StackDX Products
          </Typography>
          <ul>
            <li>
              <Link href="https://boereport.com" target="_blank">
                BOE Report
              </Link>
            </li>
            <li>
              <Link href="https://stackdx.com" target="_blank">
                StackDX Docs & Roads
              </Link>
            </li>
            <li>
              <Link href="https://petroninja.com" target="_blank">
                StackDX Maps
              </Link>
            </li>
          </ul>
        </Box>
        <Box>
          <Box display="flex" flexDirection="row">
            <LocationOnIcon sx={{ mr: 1 }} />
            <Box>
              <Typography variant="body1" gutterBottom>
                <ExternalLink href="https://www.google.com/maps/place/639+5+Ave+SW,+Calgary,+AB+T2P+0M9/@51.0484849,-114.0777935,17z/data=!3m1!4b1!4m5!3m4!1s0x53716fe4eb0fff09:0xf7b1149afa3e1b6c!8m2!3d51.0484815!4d-114.0756048">
                  639 5th Ave SW, Suite 1100
                </ExternalLink>
              </Typography>
              <Typography variant="body1" gutterBottom>
                Calgary, AB, T2P 0M9
              </Typography>
            </Box>
          </Box>

          <Box mt={2} />
          <Typography
            variant="body1"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.text.disabled,
            })}
          >
            <EmailIcon sx={{ mr: 1 }} />
            <Link href="mailto:hello@boereport.com">hello@boereport.com</Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
